import type { useSearchCardArgs } from 'components/SearchPage/components/Listings/components/SearchCard/SearchCard.hook.typed';

function useSearchCard(props: useSearchCardArgs) {
  const { parentSection, section, isGrid, age, county, countyTown, keyInfo } =
    props;

  const getCardSection = (name: string, displayName: string) => {
    return parentSection !== name ? displayName : '';
  };

  const sectionDisplayName = getCardSection(section.name, section.displayName);

  let injectedKeyInfo = [];

  if (isGrid) {
    injectedKeyInfo = [];
    if (age) injectedKeyInfo.push(age);
    if (county) {
      injectedKeyInfo.push(county);
    }
    if (sectionDisplayName) {
      injectedKeyInfo.push(sectionDisplayName);
    }
  } else {
    injectedKeyInfo = [...(keyInfo || [])];
    if (age) injectedKeyInfo.push(age);
    if (county) {
      if (countyTown) {
        injectedKeyInfo.push(`${countyTown}, ${county}`);
      } else {
        injectedKeyInfo.push(county);
      }
    }
    if (sectionDisplayName) injectedKeyInfo.push(sectionDisplayName);
  }

  return {
    injectedKeyInfo,
  };
}

export { useSearchCard };
